import { container } from "assets/jss/material-kit-react.jsx";

const carouselStyle = {
  section: {
    padding: "1px 0"
  },
  container,
  marginAuto: {
    marginLeft: "auto !important",
    marginRight: "auto !important"
  }
};

export default carouselStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx